import { jsx } from "react/jsx-runtime";
import dynamic from "next/dynamic";
const PreviewProvider = dynamic(() => import("./PreviewProvider"));
const LiveProvider = dynamic(() => import("./LiveProvider"));
function RuntimeProvider({ preview, ...props }) {
  return preview ? /* @__PURE__ */ jsx(PreviewProvider, { ...props }) : /* @__PURE__ */ jsx(LiveProvider, { ...props });
}
export {
  RuntimeProvider
};
//# sourceMappingURL=RuntimeProvider.js.map